import Form from '@/libs/form';

const fields = ['id', 'title', 'description', 'title_en', 'description_en', 'status'];

const rules = {
   title: 'required',
};

export default Form.create(fields).validate(rules);
